import { LoadNextExpiration } from "../../domain/use-case/LoadNextExpiration";
import { HttpGetClient } from "../protocols/adapters/HttpGetClient";

export class RemoteLoadExpiration implements LoadNextExpiration {
  private readonly httpClient: HttpGetClient

  constructor(httpClient: HttpGetClient) {
    this.httpClient = httpClient
  }

  async handle (params: LoadNextExpiration.Params): Promise<LoadNextExpiration.Result> {
    const token = localStorage.getItem('token')
    const response = await this.httpClient.get({
      url: `/expirations`,
      data: { catalogId: params.catalogId },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  }
}